import { ShieldAlert } from "lucide-react";

export const AmbassadorComplianceBar = ({ foundingMembership, onOpenClaimModal, pendingCount, publicPath }) => (
  <div className="mt-5 rounded-[26px] border border-[#D4AF37]/22 bg-[linear-gradient(135deg,#1A1A1A_0%,#232323_100%)] px-5 py-4 text-[#F6F1E9] shadow-[0_18px_40px_rgba(22,18,11,0.22)]" data-testid="ambassador-compliance-status-bar">
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex items-start gap-3">
        <ShieldAlert className="mt-0.5 h-5 w-5 text-[#D4AF37]" />
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">Compliance Status: Action Required</p>
          <p className="mt-2 text-sm leading-7 text-[#B8B0A5]">
            {pendingCount} synced listings are locked inside your Private Showroom at <span className="font-semibold">{publicPath}</span>. Complete Claim & Verify first, then secure one of the {foundingMembership?.available_count ?? 12} currently available Founding 18 seats to publish.
          </p>
        </div>
      </div>
      <button className="outline-button !border-[#D4AF37]/24 !bg-white/5 !text-[#F6F1E9] hover:!bg-white/10" data-testid="ambassador-open-claim-verify-button" onClick={onOpenClaimModal} type="button">
        Open Claim & Verify
      </button>
    </div>
  </div>
);